import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { transformSucessResponse, transformErrorResponse } from "../../utils/API/responseMiddleware";
import { transformRequest, encryptQueryString } from "../../utils/API/requestMiddleware"
// import { defautBaseQuery } from '../../utils/API/fetchBaseQuery';
import { customFetchBase } from '../../utils/API/fetchBaseQuery';

const interviewTypeAPI = createApi({
    reducerPath: 'interviewTypeAPI',
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        //** Delete API */
        deleteInterviewType: builder.mutation({
            query: (id) => ({
                url: `/InterviewType/DeleteInterviewType/?id=${id}`,
                method: 'DELETE',
                body: transformRequest(id)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        //**  Update API */
        updateInterviewType: builder.mutation({
            query: (Details) => ({
                url: '/InterviewType/UpdateInterviewType',
                method: 'POST',
                body: transformRequest(Details)
            }),
            invalidatesTags: ['InterviewType'],
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        //** Add  API */ 
        addInterviewType: builder.mutation({
            query: (Details) => ({
                url: '/InterviewType/AddInterviewType',
                method: 'POST',
                body: transformRequest(Details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getInterviewTypeList: builder.mutation({
            query: (userQuery) => ({
                url: encryptQueryString(`/InterviewType/GetInterviewTypeList`),
                method: 'POST',
                body: transformRequest(userQuery)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

    })
})

export const {
    useDeleteInterviewTypeMutation,
    useAddInterviewTypeMutation,
    useUpdateInterviewTypeMutation,
    useGetInterviewTypeListMutation
} = interviewTypeAPI;

export default interviewTypeAPI;